import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  standalone: false,
  styleUrls: ['./../error.scss'],
  template: `<div class="container-fluid">
  <div class="row">
      <div class="col">
          <div class="no-data">
            <div>
              <h1>Access Denied</h1>
              <span>Oops! Seems you don't have access to DMA. Please reach out to Biz App team for your access role configuration.</span>
              <a class="btn-brand primary d-inline-block mt-2" [routerLink]="['/']">Try Again</a>
            </div>
          </div>
      </div>
  </div>
</div>`
})
export class UnauthorizedComponent{
}
